export default "__VITE_ASSET__db1d77df__"